import { HttpService, L10nBase, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { VatRateItem, VatRatePLSymbol } from './vat-rate-item';


export class VatRateForSaleQuery extends Query<VatRateItem[]> { }

interface VatRateFormSaleInternalItem {
    readonly communityTransactions: Readonly<number[]>;
    readonly version: string;
    readonly untaxed: boolean;
    readonly translateKeyName: string;
    readonly translateKeySymbol: string;
    readonly symbol: VatRatePLSymbol | string;
    readonly order: number;
    readonly rate: number;
    readonly id: number;
    readonly externalId: string;
    readonly exempt: boolean;
    readonly default: boolean;
    readonly name: string;
    readonly countryId: number;
    readonly active: boolean;
}

export class VatRateForSaleQueryHandlerBase implements QueryHandler<VatRateForSaleQuery, VatRateItem[]> {
    public static Url = TaggedUrl.join('sales/vatRates', [Tags.Api]);

    public constructor(
        private readonly http: HttpService,
        private readonly translate: L10nBase
    ) { }

    public async handleAsync(_: VatRateForSaleQuery): Promise<VatRateItem[]> {
        const { data } = await this.http.get<{ items: VatRateFormSaleInternalItem[] }>(VatRateForSaleQueryHandlerBase.Url);
        return data.items.map(i => ({
            id: i.id,
            default: i.default,
            exempt: i.exempt,
            externalId: i.externalId,
            communityTransactions: i.communityTransactions,
            name: i.translateKeyName ? this.translate.instant(`business.vat-rates.${i.translateKeyName}`) : i.name,
            order: i.order,
            rate: i.rate,
            symbol: i.translateKeySymbol ? this.translate.instant(`business.vat-rates.${i.translateKeySymbol}`) : i.symbol,
            untaxed: i.untaxed,
            countryId: i.countryId,
            active: i.active
        }));
    }
}
